<template>
  <AsideLeft class="category hidden lg:block">
    <template slot="title"> Alle Kategorien </template>
    <li
      v-for="category in productCategories"
      :key="category.id"
      class="transition"
    >
      <nuxt-link
        :to="'/shop?categories=' + category.slug"
        :class="{
          'nuxt-link-exact-active': $route.fullPath.startsWith(
            '/shop?categories=' + category.slug
          ),
        }"
      >
        {{ category.title }}
      </nuxt-link>
    </li>
  </AsideLeft>
</template>

<script>
import { mapState } from 'vuex'
import AsideLeft from '~/components/layoutelements/AsideLeft'

export default {
  components: {
    AsideLeft,
  },
  computed: {
    ...mapState('settings', ['productCategories']),
  },
}
</script>
